import React, { useMemo, useState } from 'react';

import {
  OrganizationOnboardingType,
  OrganizationPublisherOnboardingType,
} from '@ts/userOrganization.types';
import { Button } from '@uikit/Form/Button/Button';
import Textarea from '@uikit/old/Textarea/Textarea';

type Props = {
  details?: OrganizationOnboardingType;
  onSave: (details: Partial<OrganizationPublisherOnboardingType>, isCompleted: boolean) => void;
  onBack?: () => void;
  onContinue?: () => void;
};

function OnboardingPublisherReferralSource({
  details,
  onSave,
  onBack,
  onContinue,
}: Props): JSX.Element {
  const initial = useMemo(() => details?.publisher?.referralSource || '', [details]);
  const [value, setValue] = useState<string>(initial);
  const [touched, setTouched] = useState<boolean>(false);

  const charCount = useMemo(() => value.trim().length, [value]);
  const isValid = charCount >= 1;

  const handleContinue = () => {
    if (!isValid) {
      setTouched(true);
      return;
    }
    onSave({ referralSource: value }, true);
    onContinue && onContinue();
  };

  return (
    <div className="onboarding-step onboarding-step__three">
      <h2 className="onboarding-step__title">How did you hear about Respona?</h2>
      <div className="onboarding-step__content">
        <div className="onboarding-step__textarea">
          <Textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={() => setTouched(true)}
            placeholder="Respona team reached out to me via email and invited me to the publisher portal."
            resizeDisabled
            isError={touched && !isValid}
            error={touched && !isValid ? 'Please enter at least 3 words' : undefined}
          />
        </div>
      </div>
      <div className="onboarding-step__footer">
        <Button type="secondary" onClick={onBack}>
          Back
        </Button>
        <Button onClick={handleContinue} disabled={!isValid}>
          Continue
        </Button>
      </div>
    </div>
  );
}

export default OnboardingPublisherReferralSource;
